import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';

import InstantSearchLoadMore from './instantSearchLoadMore';
import InstantSearchVehicle from './instantSearchVehicle';
import StockAlertMessage from '@javascript/components/vehicle_search/stockAlertMessage';
import { useClickAndCollect } from '@javascript/lib/hooks/useClickAndCollect';
import useQueryParam from '@javascript/lib/hooks/useQueryParam';
import useRedirectURL from './hooks/useRedirectURL';

import type { InstantSearchResult } from '@javascript/types/InstantSearch';

const SkeletonCard = () => (
  <div className="ac-result ch-ba--0 ch-skeleton skeleton--card" />
);

const SkeletonCards = ({ length }: { length: number }) => {
  return (
    <>
      {Array.from({ length }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </>
  );
};

const InstantSearchResults = () => {
  const { status } = useInstantSearch();

  const { items, isLastPage, results, sendEvent, showMore } =
    useInfiniteHits<InstantSearchResult>();

  const { nbHits: totalVehicles, __isArtificial: resultsNotFetched } =
    results || {};

  const { clickAndCollectData, isLoading: clickAndCollectLoading } =
    useClickAndCollect();

  const [currentSearch] = useQueryParam();

  const redirectURL = useRedirectURL();

  const isLoading = status === 'loading';

  const shouldShowSkeletons =
    !!redirectURL || (resultsNotFetched && items.length === 0);

  if (shouldShowSkeletons) {
    return (
      <div className="ac-results">
        <SkeletonCards length={12} />
      </div>
    );
  }

  return (
    <>
      <div className="ac-results">
        {items.map((item) =>
          clickAndCollectLoading ? (
            <SkeletonCard key={item.objectID} />
          ) : (
            <InstantSearchVehicle
              {...clickAndCollectData}
              hit={item}
              key={item.objectID}
              sendEvent={sendEvent}
            />
          )
        )}
        {!resultsNotFetched && isLastPage && (
          <StockAlertMessage
            stockAlertUrl={`/stock-alerts/new${currentSearch}`}
          />
        )}
      </div>
      <InstantSearchLoadMore
        isLoading={isLoading}
        showMore={showMore}
        totalVehicles={totalVehicles}
        visibleVehicles={items.length}
      />
    </>
  );
};

export default InstantSearchResults;
